import { createSlice } from "@reduxjs/toolkit";
import {
  getCompanies,
  addNewCompany,
  updateCompany,
  deleteCompany,
} from "./thunk";

export const initialState = {
  companies: [],
  error: {},
};

const companiesSlice = createSlice({
  name: "company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCompanies.fulfilled, (state, action) => {
      state.companies = action.payload;
      state.isCompaniesFailed = false;
      state.isCompaniesSuccess = true;
    });

    builder.addCase(getCompanies.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isCompaniesFailed = true;
      state.isCompaniesSuccess = false;
    });

    builder.addCase(addNewCompany.fulfilled, (state, action) => {
      state.companies.push(action.payload);
      state.isCompanyAdd = true;
      state.isCompanyAddFail = false;
    });

    builder.addCase(addNewCompany.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isCompanyAdd = false;
      state.isCompanyAddFail = true;
    });

    builder.addCase(updateCompany.fulfilled, (state, action) => {
      state.companies = state.companies.map((company) =>
        company._id.toString() === action.payload._id.toString()
          ? { ...company, ...action.payload }
          : company
      );
      state.isCompanyUpdate = true;
      state.isCompanyUpdateFail = false;
    });

    builder.addCase(updateCompany.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isCompanyUpdate = false;
      state.isCompanyUpdateFail = true;
    });

    builder.addCase(deleteCompany.fulfilled, (state, action) => {
      state.companies = (state.companies || []).filter(
        (company) =>
          company._id.toString() !== action.payload.company.toString()
      );
      state.isCompanyDelete = true;
      state.isCompanyDeleteFail = false;
    });

    builder.addCase(deleteCompany.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isCompanyDelete = false;
      state.isCompanyDeleteFail = true;
    });
  },
});

export default companiesSlice.reducer;
